import { render, staticRenderFns } from "./password-details.vue?vue&type=template&id=7e763897"
import script from "./password-details.vue?vue&type=script&lang=js"
export * from "./password-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e763897')) {
      api.createRecord('7e763897', component.options)
    } else {
      api.reload('7e763897', component.options)
    }
    module.hot.accept("./password-details.vue?vue&type=template&id=7e763897", function () {
      api.rerender('7e763897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/login/components/reset-password/password-details.vue"
export default component.exports